import { WebhookId, WebhookResponse } from '@business/entities/webhook';
import { Endpoint } from '../endpoint';

export function fetchWebhooks() {
  return Endpoint.get<WebhookResponse[]>(`@gc/webhook`);
}

export function createWebhook(webhook: Partial<WebhookResponse>) {
  return Endpoint.post<WebhookResponse>(`@gc/webhook`, { data: { ...webhook } });
}

export function updateWebhook(id: WebhookId, webhook: Partial<WebhookResponse>) {
  return Endpoint.patch<WebhookResponse>(`@gc/webhook/${id}`, { data: { ...webhook } });
}

export function toggle(id: WebhookId) {
  return Endpoint.patch<WebhookResponse>(`@gc/webhook/toggle/${id}`);
}

export function deleteWebhook(id: WebhookId) {
  return Endpoint.delete<void>(`@gc/webhook/${id}`);
}
